import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsWeightTrainingNormalLarge = React.forwardRef(
  ({ color = "currentColor", size = 48, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M28.303 2.726a3.5 3.5 0 00-4.95 0l-2.828 2.829a3.5 3.5 0 000 4.95l4.95 4.95-10.021 10.02-4.95-4.95a3.5 3.5 0 00-4.95 0l-2.828 2.829a3.5 3.5 0 000 4.95l1.768 1.767-2.768 2.768a3.5 3.5 0 000 4.95l8.485 8.485a3.5 3.5 0 004.95 0l2.768-2.768 1.767 1.768a3.5 3.5 0 004.95 0l2.829-2.828a3.5 3.5 0 000-4.95l-4.95-4.95 10.02-10.02 4.95 4.95a3.5 3.5 0 004.95 0l2.829-2.83a3.5 3.5 0 000-4.95l-1.768-1.767 2.768-2.768a3.5 3.5 0 000-4.95l-8.486-8.485a3.5 3.5 0 00-4.95 0l-2.767 2.768-.07-.07zm14.85 19.092a.5.5 0 010 .707l-2.83 2.829a.5.5 0 01-.706 0l-16.97-16.97a.5.5 0 010-.708l2.828-2.828a.5.5 0 01.707 0l9.546 9.546 2.121-2.122-5.657-5.657 2.768-2.767a.5.5 0 01.707 0l8.485 8.485a.5.5 0 010 .707l-4.889 4.89zm-15.557-4.242l2.828 2.828-10.02 10.02-2.829-2.828zm-2.243 22.041a.5.5 0 010 .707l-2.828 2.829a.5.5 0 01-.707 0l-3.89-3.89-4.889 4.89a.5.5 0 01-.707 0l-8.485-8.486a.5.5 0 010-.707l2.768-2.768 5.657 5.657 2.122-2.121-9.547-9.546a.5.5 0 010-.707l2.829-2.828a.5.5 0 01.707 0z"
        fill=""
      />
    </svg>
  )
);
SvgSportsWeightTrainingNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsWeightTrainingNormalLarge;
